// eslint-disable-next-line import/prefer-default-export
export const toResourcePath = (id) => `/resources/${id}/`
